var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2ShoppingCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 50h26v4H30a2 2 0 01-2-2v-8.54c-.08-.3-.15-.63-.22-1L17.41 15H7v-4h11.82a2 2 0 011.87 1.29l3.7 9.71h38.08l-6.53 17L32 44.47V50zm20.17 6a4 4 0 00-3.87 3 3.85 3.85 0 00-.13 1c-.01.133-.01.267 0 .4l.1.6A4 4 0 0056 61a4.09 4.09 0 00.14-1 4 4 0 00-3.97-4zm-17.92 0a4 4 0 00-3.87 3 3.85 3.85 0 00-.13 1v.4l.1.6a4 4 0 007.86-1 4 4 0 00-3.96-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Shopping_card.89cd4793.svg";
export { SvgJ2ShoppingCard as ReactComponent };